import { Stage } from 'generated/rbi-graphql';
import { OrderingStatus } from 'utils/restaurant/constants';

export type EnvMapping = {
  [K in EnvSubtype]:
    | RBIBrand
    | RBIEnv
    | OrderingStatus
    | RBIPlatform
    | Stage
    | RBIReleaseTimestamp
    | string;
};

export enum EnvSubtype {
  AUTH = 'auth',
  BRAND = 'brand',
  FIRSTDATA_URL = 'firstDataUrl',
  GRAPHQL = 'graphql',
  PLATFORM = 'platform',
  RESTAURANT = 'restaurant',
  SANITY = 'sanity',
  RELEASE_TIMESTAMP = 'releaseTimestamp',
  VALID_MOBILE_ORDERING = 'validMobileOrdering',
}

export type RBIReleaseTimestamp = string;

export enum RBIEnv {
  DEV = 'dev',
  PROD = 'prod',
  QA = 'qa',
  SANDBOX = 'sandbox',
  STAGING = 'staging',
  TEST = 'test',
}

export enum RBIPlatform {
  APP = 'app',
  KIOSK = 'kiosk',
  WEB = 'web',
}

// Only use for logging universal attributes in mParticle
export enum RBIExpandedPlatform {
  IOS = 'iOS',
  ANDROID = 'Android',
  WEB = 'Web',
  KIOSK = 'Kiosk',
}

export enum RBIBrand {
  BK = 'bk',
  PLK = 'plk',
  TH = 'th',
}

export enum RBIFullBrandName {
  Popeyes = 'Popeyes',
  TimHortons = 'Tim Hortons',
  BurgerKing = 'Burger King',
}

export enum RBIAppUriScheme {
  Popeyes = 'popeyes://',
  TimHortons = 'timhortons://',
  BurgerKing = 'burgerking://',
}

export enum Service {
  amplitude = 'AMPLITUDE',
  branch = 'BRANCH',
  braze = 'BRAZE',
  bringg = 'BRINGG',
  mParticle = 'MPARTICLE',
  launchDarkly = 'LAUNCH_DARKLY',
  logRocket = 'LOGROCKET',
  radar = 'RADAR',
  googleMaps = 'GOOGLE_MAPS',
  googleAnalytics = 'GOOGLE_ANALYTICS',
}
